// extracted by mini-css-extract-plugin
export var buttonContainer = "style-module--buttonContainer--36e16";
export var confirm = "style-module--confirm--3e66b";
export var errorMessage = "style-module--errorMessage--89d43";
export var input = "style-module--input--4362f";
export var mail = "style-module--mail--35e04";
export var resent = "style-module--resent--e6a52";
export var text = "style-module--text--a1931";
export var title = "style-module--title--1c84c";